<template>
	<div class="animated fadeIn">
		<CTabs  variant="pills" :active-tab="active_tab" @update:activeTab="changeTab" >
			<CTab title="Fields"/>
			<CTab title="Create New Field" v-if="$store.getters['can']('create-field')"/>
		</CTabs>
		<hr>
		<div>
	        <router-view @activeTab="emitHomeTab($event)">

	        </router-view>
	    </div>
	</div>
</template>
<script>
export default {
	name: 'FieldHome',
	data() {
		return {
			active_tab: this.$router.history.current.path.substring(this.$router.history.current.path.lastIndexOf('/') + 1) == 'create' ? 1 : 0,
		}
	},
	methods: {
		changeTab: function(item) {
			this.$router.push(!item ? `/${this.$store.getters.getOrganizationName}/form-management/field` : `/${this.$store.getters.getOrganizationName}/form-management/field/create`)
			this.active_tab = item;
		},
		emitHomeTab: function (value) {
			this.active_tab = value
		}
	}
}
</script>